<!-- Post Component - Usando componentes modulares de feeds -->
<div class="space-y-6" *ngIf="user">
  <!-- Mensajes de estado -->
  <div *ngIf="error" class="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg">
    {{ error }}
  </div>

  <div
    *ngIf="success"
    class="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg"
  >
    {{ success }}
  </div>

  <!-- Formulario para crear post (solo si es el propio perfil) -->
  <div *ngIf="user.isOwnProfile && isLoggedIn">
    <app-post-creator
      [placeholder]="'Comparte tu conocimiento y experiencias académicas...'"
      [buttonText]="'Publicar en tu perfil'"
      [showOptions]="true"
      [userAvatar]="user.profile_picture || '/assets/profile.png'"
      [userName]="user.first_name + ' ' + user.last_name"
      [isLoading]="isSubmittingPost"
      (postSubmitted)="onPostSubmitted($event)"
    >
    </app-post-creator>
  </div>

  <!-- Lista de posts usando el componente modular -->
  <app-post-list
    [posts]="posts"
    [isLoading]="isLoading"
    [emptyMessage]="'No hay publicaciones en este perfil'"
    [showActions]="isLoggedIn"
    [currentUserId]="currentUserId"
    (toggleLike)="onToggleLike($event)"
    (deletePost)="onDeletePost($event)"
    (sharePost)="onSharePost($event)"
    (viewProfile)="onViewProfile($event)"
    (editPost)="onEditPost($event.postId)"
  >
  </app-post-list>
</div>
